<template>
  <b-dropdown right class="add-assignment-wrap">
    <template #button-content>
      <mdicon name="plus" size="24" />
    </template>

    <b-dropdown-item :to="single">Single-item assignment</b-dropdown-item>
    <b-dropdown-item :to="batch">Batch assignment</b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import type { RouterLink } from '@/types/Components/Router'
import { defineComponent } from 'vue'
import { SINGLE } from '@/const/AssignmentTypes'
import { STAFF_ASSIGNMENTS_CREATE } from '@/types/router'

export default defineComponent({
  name: 'AddButton',
  setup() {
    const single: RouterLink = {
      name: STAFF_ASSIGNMENTS_CREATE,
      query: {
        assignmentType: SINGLE,
      },
    }

    const batch: RouterLink = {
      name: STAFF_ASSIGNMENTS_CREATE,
    }

    return {
      single,
      batch,
    }
  },
})
</script>
